import React from 'react';
import { useIntl } from 'react-intl';
import { DragDrop, StatusBar } from '@uppy/react';

const DatasetAttachmentsDragDrop = ({ canUpload, error, uppy }) => {
  const intl = useIntl();
  return (
    <>
      <DragDrop
        uppy={uppy}
        locale={{
          strings: {
            browse: intl.formatMessage({ id: 'upload.dashboard.browse' }),
            dropHereOr: intl.formatMessage({ id: 'upload.dashboard.drop.attachments' }, { browse: '%{browse}' }),
          },
        }}
      />
      {canUpload && !error && (
        <StatusBar
          className="aridhia-dataset-attachments-table-status-uppy"
          hideAfterFinish
          hideUploadButton
          locale={{ strings: { retry: '', filesUploadedOfTotal: '' } }}
          showProgressDetails
          uppy={uppy}
        />
      )}
    </>
  );
};

export default DatasetAttachmentsDragDrop;
